import { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {

    const notifySuccess = ( msg ) => {
        toast.success( msg, {
            position: "top-center",
            autoClose: 3000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark"
        })
    }

    const notifyError = ( msg ) => {
        toast.error( msg, {
            position: "top-center",
            autoClose: 5000,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark"
        })
    }

    return(
        <ToastContext.Provider value={{ notifySuccess, notifyError }} >
            { children }
            <ToastContainer
                style={{ zIndex: 999999 }}
            />
        </ToastContext.Provider>
    )

}

export const useToast = () => useContext( ToastContext )